import React from "react";
import { useSelector } from "react-redux";
import UsedInLink from "../UsedInLink";
import { selectEventHandlers } from "../../../store/slices/projectSlice";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import labels from "../../nodes/Logic/helpers/labels";
import SidebarScroll from "./SidebarScroll";
import SidebarCollapseButton from "./SidebarCollapseButton";

export default function ActionsPanel() {
  const eventHandlers = useSelector(selectEventHandlers);
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-center">
        <h5 className="card-title mb-0">
          Actions
          <HelpButton helpKey="actions-panel" />
        </h5>
        <SidebarCollapseButton
          collapsed={collapsed}
          onClick={() => setCollapsed((value) => !value)}
        />
      </div>
      {!collapsed && (
        <div className="card-body p-0">
          <SidebarScroll>
            <ul className="list-group list-group-flush">
              {[
                ...new Set(
                  eventHandlers.flatMap((eh) =>
                    eh.Rules.flatMap((r) =>
                      r.Actions?.map((action) => action.Type) || []
                    )
                  )
                ),
              ].map((actionType) => (
                <li key={actionType} className="list-group-item p-2">
                  <div className="d-flex justify-content-between align-items-baseline">
                    <span className="">{labels[actionType]}</span>
                    <UsedInBadge arg={{ Type: actionType, UUID: actionType }} />
                  </div>
                </li>
              ))}
            </ul>
          </SidebarScroll>
        </div>
      )}
    </div>
  );
}
